import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeContentsList} from './doppe-action-type-contents-list';
import React from 'react';

export const doppeActionTypeContentsListViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeContentsList, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeContentsListWidget: (await import('./doppe-action-type-contents-list-widget/doppe-action-type-contents-list-widget')).DoppeActionTypeContentsListWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeContentsListWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeContentsListWidget
                {...renderProps}
            />
        );

    }
})